NINEBOX_API_URL = "https://api.9boxnow.com/api/v1/";
NINEBOX_BASE_URL = "https://9boxnow.com";

SUCCESSION_API_URL = "https://api.successionnow.com/api/v1/";
SUCCESSION_BASE_URL = "https://successionnow.com";


export var NINEBOX_API_URL;
export var SUCCESSION_API_URL;
export var NINEBOX_BASE_URL;
export var SUCCESSION_BASE_URL;